import { isHttpError } from './isHttpError'

const hasStringMessage = (body: unknown): body is { message: string } =>
    typeof body === 'object' &&
    body !== null &&
    'message' in body &&
    typeof body.message === 'string'

export const getHttpErrorResponseMessage = async (error: unknown) => {
    if (!isHttpError(error)) {
        return undefined
    }

    try {
        const body: unknown = await error.response.clone().json()

        return hasStringMessage(body) ? body.message : undefined
    } catch {
        return undefined
    }
}
